// extracted by mini-css-extract-plugin
export default {"container":"J5CXbu","title":"eJ9Xlq qRatTb","cover":"Havxlp Riqxa6 mz-cover"};